export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automatisierung",
    title: "Wann werden die Ankunftsinformationen gesendet?",
    desc: "Aktivieren Sie jedes Ereignis und legen Sie fest, <strong>wann</strong> es gesendet wird: sobald <strong>ein Gast</strong> seine Registrierung abschließt oder erst, wenn <strong>alle</strong> Gäste der Buchung ihre Registrierung abschließen.",
    loading: "Einstellungen werden geladen…",
    welcomeName: "Willkommensnachricht",
    welcomeSub: "Die Willkommensnachricht, die der Gast direkt nach Abschluss seiner Registrierung erhält.",
    documentName: "Unterzeichnetes Bedingungsdokument",
    documentSub: "Das Dokument, das der Gast während der Registrierung unterschreibt. Wir senden es als PDF, damit er es in WhatsApp oder per E-Mail hat.",
    timingIndividual: "Sobald ein Gast seine Registrierung abschließt",
    timingAll: "Wenn alle Gäste der Buchung die Registrierung abschließen",
    timingQuestion: "Wann wird gesendet?",
    eventOffNote: "Dieses Ereignis wird nicht automatisch gesendet.",
    infoBox: "Änderungen werden automatisch gespeichert. Der Zugangscode folgt bei Unterkünften mit smartem Schloss seiner eigenen Konfiguration.",
    loadError: "Die Einstellungen konnten nicht geladen werden.",
    saveError: "Die Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  },
  checkinProcess: {
    colEmail: "E-Mail",
    colSendDate: "Sendedatum",
    colStatus: "Status",
    unspecified: "Nicht angegeben",
    complete: "Abgeschlossen",
    pending: "Ausstehend",
  },
  listBookings: {
    title: "Check-in-Liste",
    subtitle: `Übersicht der Check-ins Ihrer Gäste`,
    accommodation: "Unterkunft",
    all: "Alle",
    from: "Von",
    to: "Bis",
    search: "Suchen",
    today: "Heute",
    noDate: "Kein Datum",
    clear: "Leeren",
    exporting: "Wird exportiert...",
    exportCheckins: "Exportieren",
    ricevutaBtn: "Polizeibeleg",
    ricevutaTitle: "Beleg der italienischen Polizei",
    ricevutaHint: "Der offizielle Alloggiati-Web-Beleg mit allen an jedem Tag gesendeten Check-ins. Ein Tag lädt ein PDF herunter; mehrere ein ZIP mit einem PDF pro Tag (max. 31).",
    ricevutaFrom: "Von",
    ricevutaTo: "Bis",
    ricevutaAccount: "Polizeikonto",
    ricevutaDownload: "PDF herunterladen",
    ricevutaDownloading: "Wird heruntergeladen…",
    ricevutaCancel: "Abbrechen",
    ricevutaError: "Der Beleg konnte nicht heruntergeladen werden.",
    noAccommodation: "Keine Unterkunft",
    noReservation: "Keine Buchung",
    travelerReport: "Gästemeldung (Mossos)",
    noRecords: "Keine Einträge",
    noRecordsFiltered: "Mit den gewählten Filtern wurden keine Einträge gefunden.",
    noCheckinsTitle: "Noch keine Check-ins erfasst",
    noCheckinsSub: `Sobald Ihre Gäste ihren Check-in abschließen, sehen Sie sie hier mit allen Angaben.`,
    excelSuccess: "Check-ins als Excel heruntergeladen",
    excelSuccessTitle: "Export abgeschlossen",
    excelError: `Die Check-ins konnten nicht exportiert werden`,
    errorTitle: "Fehler",
    listingNotIdentified: "Das Inserat des Check-ins konnte nicht ermittelt werden",
    comprobanteNotAvailable: "Der Beleg ist für diesen Check-in noch nicht verfügbar",
    comprobanteDownloadError: "Der Beleg konnte nicht heruntergeladen werden",
  },
  modalFirstCheckin: {
    loading: "Wird geladen...",
    sendingLinkWait: "Der Check-in-Link wird gesendet, bitte warten...",
    phoneRequired: "Um fortzufahren, müssen Sie die WhatsApp-Nummer eingeben",
    sendingLink: "Link wird gesendet ...",
    almostThere: "Fast geschafft, bitte warten...",
    sentSuccess: "Erfolgreich gesendet",
    sendError: "Fehler beim Senden des Check-ins",
    title: "Testen Sie jetzt einen Check-in mit Ihrem eigenen Handy",
    enterWhatsapp: "Geben Sie Ihre WhatsApp-Nummer ein",
    invalidNumber: `Ungültige Nummer. Achten Sie auf die Vorwahl mit "+".`,
    skip: "Überspringen",
    sendFirstCheckin: "Ersten Check-in senden",
    sendCheckin: "Check-in senden",
  },
  tableRetriveCheckinPending: {
    colEmail: "E-Mail",
    colSendDate: "Sendedatum",
    colStatus: "Status",
    unspecified: "Nicht angegeben",
    complete: "Abgeschlossen",
    pending: "Ausstehend",
    emptyMessage: `Sie haben noch keine laufenden Check-ins`,
  },
  rerservationModal: {
    night: "Nacht",
    nights: "Nächte",
    minStayBanner: "Für den gewählten Zeitraum gilt ein Mindestaufenthalt von {count} {nights} (OTA-Regel). Gewählte Nächte: {selected}.",
    freeUnits: "Verfügbare Einheiten: {count}",
    noAvailabilityDetailed: "Keine Verfügbarkeit für diese Daten. {details}",
    noAvailability: "Keine Verfügbarkeit für diese Daten.",
    hotelAvailabilityError: "Die Verfügbarkeit konnte nicht geprüft werden (Hotel).",
    minStayWarning: "Für den Anreisetag sind mindestens {count} Nächte erforderlich. Sie haben {selected} gewählt.",
    notEnoughAvailability: "Es gibt nicht genügend Verfügbarkeit. Verfügbare Einheiten: {count}.",
    noAvailabilityDates: "Für die gewählten Daten gibt es keine Verfügbarkeit.",
    departureAfterArrival: "Die Abreise muss nach der Anreise liegen.",
    close: "Schließen",
    noMatches: "Keine Treffer",
    noAccommodations: "Es gibt keine Unterkünfte",
    searchingGuests: "Gäste werden gesucht...",
    noName: "Kein Name",
    priceLocked: "Der Buchungspreis kann nicht geändert werden.",
    otaMoveHint: "Sie können sie in eine andere Unterkunft desselben Inserats verschieben; der Kanal wird benachrichtigt.",
    otaMoveHintCuenta: "Sie können sie in jede Ihrer Unterkünfte verschieben. Gehört sie zum selben Inserat, wird der Kanal benachrichtigt.",
    otaRelocateNote: "Das ist ein anderes Inserat: Die Buchung wird in WACheckin verschoben, aber der Kanal führt sie weiter in der Unterkunft, in der sie verkauft wurde. Änderungen und Stornierungen erreichen Sie weiterhin.",
    extrasTitle: "Weitere Optionen",
    extrasSub: "Wählen Sie aus, was Sie berechnen und welchen Rabatt Sie gewähren",
    quoteTitle: "Was Ihre Direktbuchung berechnet",
    quoteHint: "Wählen Sie aus, was Sie bei dieser Buchung berechnen möchten. Die Nächte sind immer enthalten.",
    quoteOptions: "1 auswählbar | {count} auswählbar",
    quoteNoExtras: "Für diese Unterkunft sind in der Direktbuchung keine Reinigungsgebühr und keine Zuschläge eingerichtet.",
    quoteStay: "Aufenthalt · {count} Nacht | Aufenthalt · {count} Nächte",
    quoteExtraGuest: "Zusatzgast | {count} Zusatzgäste",
    quoteDiscount: "Rabatte und Aktionen",
    quoteOccupancyDiscount: "Belegungsrabatt",
    quoteCleaning: "Reinigungsgebühr",
    quoteTotal: "Gesamt",
    quoteUse: "Diesen Preis übernehmen",
    quoteNoRate: "Kein Tarif für diese Daten: Geben Sie den Preis selbst ein.",
    quoteLinePrice: "Preis für diese Unterkunft",
    unitsAdd: "Weitere Unterkunft aus dem Inserat hinzufügen…",
    unitsGuests: "Gäste in dieser Unterkunft",
    unitsRemove: "Aus der Buchung entfernen",
    unitsGroupError: "Die Buchung mit mehreren Unterkünften konnte nicht erstellt werden.",
    resendTitle: "Bestätigungsnachricht erneut senden",
    resendSub: "Sendet die Bestätigungsvorlage erneut an den Gast.",
    resendNote: "Wenn Sie die Buchung ändern, wird für diese Buchung <strong>die Bestätigungsvorlage erneut gesendet</strong>.",
    saving: "Wird gespeichert...",
  },
};
